// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1O690","colMin":"styles_colMin__4KrOd"};